import { CurrentPayPlan } from '@ace-clublabs/common-membership-api-types';

export const CACHED_MEMBERSHIP_STATUS_KEY = 'CACHED_MEMBERSHIP_STATUSES';
export const CACHED_PARTNER_ENROLLMENT_STATUS_KEY = 'CACHED_PARTNER_ENROLLMENT_STATUSES';

export const envMapForJoinUrl: { [env: string]: string } = {
  dev1: 'qamvc',
  dev2: 'qa2mvc',
  qa1: 'qamvc',
  qa2: 'qa2mvc',
  uat1: 'uatmvc',
  uat2: 'uat2mvc',
  prod: 'apps',
};

export const ClubCode = {
  alabama: '001',
  calif: '004',
  hawaii: '018',
  northernnewengland: '036',
  autoclubmo: '065',
  eastcentral: '215',
  texas: '252',
  tidewater: '258',
  newmexico: '601',
  unknown: '000',
};

export const ExternalCTAs = {
  homepage: 'https://ace.aaa.com',
};

export const autoPayBillPlans = [
  CurrentPayPlan.RECURRINGCREDITORDEBITCARD,
  CurrentPayPlan.RECURRINGELECTRONICCHECK,
  CurrentPayPlan.RECURRINGMONTHLY,
];

export const splunkRUM = {
  SPLUNK_RUM_AUTH: '6jLucdIaeND4Wmp_lwpnpw',
  SPLUNK_REALM: 'us1',
  SPLUNK_APP_NAME: 'Membership-New-Join',
};
